import Backbone from 'backbone';
import ko from 'knockout';
import template from '@bingads-webui-campaign-legacy/ad-schedule/template/date-settings.pug';
import ViewModel from '@bingads-webui-campaign-legacy/ad-schedule/viewmodel/date-settings';
import '@bingads-webui-component-legacy/datepicker/binding/datePicker';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');

export default class View extends Backbone.View {
  initialize({
    startDate = null,
    endDate = null,
    adGroupStatus = undefined,
    timeZone = 'PacificTimeUSCanadaTijuana',
    activityLogger,
    callOnChangeCb,
    isCreate,
    allowNoEndDateSelection = true,
    allowStartDateSelection = true,
    allowEndDateSelection = true,
  } = {}) {
    this.viewModel = new ViewModel({
      startDate,
      endDate,
      adGroupStatus,
      timeZone,
      activityLogger,
      callOnChangeCb,
      isCreate,
      allowNoEndDateSelection,
      allowStartDateSelection,
      allowEndDateSelection,
    });

    this.activityLogger = activityLogger;
    return this;
  }

  render() {
    this.$el.html(template({ i18n }));
    ko.applyBindings(this.viewModel, this.el);

    return this;
  }

  getValues() {
    return this.viewModel.getValues();
  }

  validate() {
    const isValid = this.viewModel.validate();

    if (!isValid && this.activityLogger) {
      this.activityLogger.signal('date setting is not valid', 'ad schedule');
    }

    return isValid;
  }
}
